import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { FIB } from '@/config/constants';
import { get } from 'vuex-pathify';
export default {
  name: 'FibEmoji',
  props: {
    value: {
      // In order to allow null (from N/A ratings, we have to programmatically validate, rather than declare interfaces)
      validator: function validator(prop) {
        return typeof prop === 'string' || typeof prop === 'number' || typeof prop === 'boolean' || Array.isArray(prop) || prop === null;
      }
    },
    options: Array,
    short: {
      type: Boolean
    },
    disable: {
      type: Boolean
    },
    isComments: {
      type: Boolean
    },
    isSingle: {
      type: Boolean
    },
    isShared: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      hoverRating: null,
      dataType: ''
    };
  },
  computed: {
    survey: get('questions/getSurvey'),
    renderType: function renderType() {
      return this.survey.indicatorsRenderType;
    },
    isStars: function isStars() {
      return (this.renderType == FIB.INDICATORS_RENDER_TYPE.CUSTOM_RATING || this.renderType == FIB.INDICATORS_RENDER_TYPE.RATING) && !this.short && !this.isSingle;
    },
    presetEmojis: function presetEmojis() {
      return [{
        rating: 1,
        filename: 'evil.svg'
      }, {
        rating: 2,
        filename: 'sad.svg'
      }, {
        rating: 3,
        filename: 'neutral.svg'
      }, {
        rating: 4,
        filename: 'good.svg'
      }, {
        rating: 5,
        filename: 'perfect.svg'
      }];
    },
    allEmojis: function allEmojis() {
      return [{
        val: '1',
        label: '',
        title: this.$t('common.emoji.worst'),
        src: this.getRenderTypeSrc(1)
      }, {
        val: '2',
        label: '',
        title: this.$t('common.emoji.bad'),
        src: this.getRenderTypeSrc(2)
      }, {
        val: '3',
        label: '',
        title: this.$t('common.emoji.neutral'),
        src: this.getRenderTypeSrc(3)
      }, {
        val: '4',
        label: '',
        title: this.$t('common.emoji.good'),
        src: this.getRenderTypeSrc(4)
      }, {
        val: '5',
        label: '',
        title: this.$t('common.emoji.perfect'),
        src: this.getRenderTypeSrc(5)
      }];
    },
    numValEmojis: function numValEmojis() {
      return this.allEmojis.map(function (v) {
        v.val = parseInt(v.val);
        return v;
      }) || [];
    },
    emojisLongList: function emojisLongList() {
      return this.numValEmojis.filter(function (v) {
        return [1, 2, 3, 4, 5].indexOf(v.val) !== -1;
      });
    },
    emojisShortList: function emojisShortList() {
      return this.numValEmojis.filter(function (v) {
        return [2, 3, 4].indexOf(v.val) !== -1;
      });
    },
    emojisNoNeutralList: function emojisNoNeutralList() {
      return this.numValEmojis.filter(function (v) {
        return [2, 4].indexOf(v.val) !== -1;
      });
    },
    styleSize: function styleSize() {
      return this.isShared ? ' 40px' : '60px';
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    styleDefault: function styleDefault() {
      return {
        color: this.theme.primaryColor,
        backgroundColor: this.theme.unselectedColor,
        boxShadow: "0 2px 0 0 ".concat(this.theme.unselectedBorderColor)
      };
    },
    styleSelected: function styleSelected() {
      return {
        color: this.isShared ? this.theme.unselectedColor : this.theme.primaryColor
      };
    }
  },
  created: function created() {
    // Set the data type to be used in the data- tags
    this.dataType = (this.csat ? 'csat-' : '') + (this.isStars ? 'rating' : 'emoji');
  },
  methods: {
    handleClick: function handleClick(value) {
      this.$emit('click', value);
    },
    handleInput: function handleInput(event) {
      this.$emit('input', event);
      this.$emit('fc-fake-click', event);
    },
    emojiShare: function emojiShare(value) {
      if (this.renderType == FIB.INDICATORS_RENDER_TYPE.CUSTOM_RATING) {
        return this.numValEmojis.filter(function (v) {
          return [1].indexOf(v.val) !== -1;
        });
      } else {
        return this.numValEmojis.filter(function (v) {
          return [value].indexOf(v.val) !== -1;
        });
      }
    },
    emojis: function emojis(value) {
      var _this = this;

      if (this.isShared) {
        return this.emojiShare(value);
      } else {
        var renderEmojis; // If options passed as prop, calculate based on options

        if (Array.isArray(this.options)) {
          renderEmojis = this.options;
        } // else by props
        else if (this.noNeutral) {
          renderEmojis = this.emojisNoNeutralList;
        } else if (this.short) {
          renderEmojis = this.emojisShortList;
        } // if no other description provided, return long list
        else {
          renderEmojis = this.emojisLongList;
        } // Check to see if isSingle or not


        if (this.isSingle) {
          // If Single then we only want to return the selected Emoji
          return renderEmojis.filter(function (e) {
            return _this.getSelected(e.val, _this.value);
          });
        } else {
          return renderEmojis;
        }
      }
    },
    getSelected: function getSelected(val, value) {
      if (this.isStars) {
        return val <= value;
      } else {
        return val === value;
      }
    },
    getRenderTypeSrc: function getRenderTypeSrc(value) {
      if (this.renderType == FIB.INDICATORS_RENDER_TYPE.EMOJI) {
        return 'statics/icons/emojis/' + this.presetEmojis.find(function (item) {
          return item.rating == value;
        }).filename;
      }

      if (this.renderType == FIB.INDICATORS_RENDER_TYPE.RATING) {
        return 'statics/icons/emojis/star.svg';
      }

      if (this.renderType == FIB.INDICATORS_RENDER_TYPE.CUSTOM_RATING) {
        return this.survey.ratingImages[this.survey.indicatorsRenderType];
      }

      if (this.renderType == FIB.INDICATORS_RENDER_TYPE.CUSTOM_EMOJI) {
        return this.survey.ratingImages[this.survey.indicatorsRenderType][value];
      }
    }
  }
};